import styled from "styled-components";
import COLORS from '../../../utils/color';

export const ToggleContainer = styled.div`
display: flex;
flex-direction: row;
flex-wrap: nowrap;
align-items: center;
margin: 0;
height: 49px;
`;

export const StyledLabel = styled.label<{ checked: boolean }>`
cursor: pointer;
text-indent: -9999px;
width: 55px;
height: 36px;
background: ${({ checked }) => (checked ? COLORS.GREEN : COLORS.GRAY)};
display: block;
border-radius: 100px;
position: relative;
margin-left: auto;

&:after {
  content: "";
  position: absolute;
  left: ${({ checked }) => (checked ? "20px" : "5px")};
  top: 3px;
  width: 30px;
  height: 30px;
  background: #fff;
  border-radius: 90px;
  transition: 0.3s;
}
`;
export const MiniStyledLabel = styled.label<{ checked: boolean }>`
cursor: pointer;
text-indent: -9999px;
top: 12px;
width: 13px;
height: 13px;
background: ${({ checked }) => (checked ? COLORS.GREEN : COLORS.GRAY)};
display: block;
border-radius: 100px;
position: relative;
margin-left: auto;
`;


export const StyledLabelMC = styled.label<{ checked: boolean }>`
cursor: pointer;
text-indent: -9999px;
width: 55px;
height: 36px;
background: ${({ checked }) => (checked ? COLORS.GREEN : COLORS.GRAY)};
display: block;
border-radius: 100px;
position: relative;
margin-left: auto;

&:after {
  content: "";
  position: absolute;
  left: ${({ checked }) => (checked ? "20px" : "5px")};
  top: 3px;
  width: 30px;
  height: 30px;
  background: #fff;
  border-radius: 90px;
  transition: 0.3s;
}
`;

export const MiniStyledLabelMC = styled.label<{ checked: boolean }>`
cursor: pointer;
text-indent: -9999px;

width: 13px;
height: 13px;
background: ${({ checked }) => (checked ? COLORS.SEAGREEN : COLORS.GRAY)};
display: block;
border-radius: 100px;
position: relative;
margin-left: 7px;
`;

export const StyledLabelPeriodo = styled.label<{ checked: boolean }>`
cursor: pointer;
text-indent: -9999px;
width: 55px;
height: 31px;
background: #ccc;
display: block;
border-radius: 100px;
position: relative;
margin-left: auto;
content: "";

&:after {
  content: "";
  position: absolute;
  left: ${({ checked }) => (checked ? "24px" : "5px")};
  top: 3px;
  width: 25px;
  height: 25px;
  background: #fff;
  border-radius: 90px;
  transition: 0.3s;
}
`;